<jsg-single-row-panel>
  <div first>
    <div>Law Firm</div>
    <div>{{ lawFirmName }}</div>
  </div>
  <div second>
    <div>Requester</div>
    <div>
      {{ firstName + ' ' + lastName }}
    </div>
  </div>
  <div third>
    <div>Email Address</div>
    <div>{{ email }}</div>
  </div>
</jsg-single-row-panel>
